import { render, staticRenderFns } from "./NutritionalGuidance.vue?vue&type=template&id=a01a70d0&scoped=true&"
import script from "./NutritionalGuidance.vue?vue&type=script&lang=js&"
export * from "./NutritionalGuidance.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalGuidance.vue?vue&type=style&index=0&id=a01a70d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01a70d0",
  null
  
)

export default component.exports